// Extracted from sections/ov-pdp-placeorder.liquid (perf lot 1). Classic script loaded with defer.
var _pdpHeroEl = document.getElementById('pdp-hero');
if (_pdpHeroEl && !_pdpHeroEl.dataset.ovInit) {
  _pdpHeroEl.dataset.ovInit = '1';

  // ── Accordion ──────────────────────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    var head = e.target.closest('.ov-acc-head');
    if (!head) return;
    var item = head.closest('.ov-acc-item');
    if (!item) return;
    var open = item.getAttribute('data-acc-open') === 'true';
    item.setAttribute('data-acc-open', open ? 'false' : 'true');
  });

  // ── Gallery thumbnails ─────────────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('[data-pdp-thumb]');
    if (!thumb) return;
    var idx = parseInt(thumb.getAttribute('data-pdp-thumb'), 10);
    thumb.parentElement.querySelectorAll('[data-pdp-thumb]').forEach(function(t) {
      t.style.borderColor = t === thumb ? '#181831' : 'transparent';
    });
    document.querySelector('[data-pdp-gallery-main]')
      .querySelectorAll('[data-pdp-main-img]').forEach(function(img) {
        img.style.display = parseInt(img.getAttribute('data-pdp-main-img'), 10) === idx ? 'block' : 'none';
      });
  });

  // ── Countdown ──────────────────────────────────────────────────────────────
  function tickCountdown() {
    var el = document.getElementById('ov-pdp-countdown');
    if (!el) return;
    var now = new Date();
    var t = new Date(now);
    t.setHours(14, 0, 0, 0);
    if (now >= t) t.setDate(t.getDate() + 1);
    var d = Math.max(0, t - now);
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    el.textContent = pad(Math.floor(d / 3600000)) + 'h ' + pad(Math.floor((d % 3600000) / 60000)) + 'min ' + pad(Math.floor((d % 60000) / 1000)) + 'sec';
  }
  tickCountdown();
  setInterval(tickCountdown, 1000);

  // ── UGC slider ─────────────────────────────────────────────────────────────
  (function() {
    var track = document.getElementById('ov-pdp-ugc-track');
    if (!track) return;
    var CARD = 208;
    function updateDots() {
      var idx = Math.round(track.scrollLeft / CARD);
      document.querySelectorAll('[data-ugc-dot]').forEach(function(d, i) {
        d.style.opacity = i === idx ? '1' : '0.25';
      });
    }
    var prev = document.getElementById('ov-pdp-ugc-prev');
    var next = document.getElementById('ov-pdp-ugc-next');
    if (prev) prev.addEventListener('click', function() { track.scrollBy({ left: -CARD, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function() { track.scrollBy({ left: CARD, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateDots, { passive: true });
  })();

  // ── Sticky bar IntersectionObserver ───────────────────────────────────────
  // Masquee quand la Hero, le bloc ATC ou le footer sont a l'ecran (redondants
  // avec eux), visible partout ailleurs sur la page. Le footer est plus bas
  // dans le DOM et n'existe pas encore quand ce script inline s'execute, donc
  // on attend DOMContentLoaded pour le trouver de maniere fiable.
  function initPdpStickyBar() {
    var bar = document.getElementById('ov-pdp-sticky-bar');
    // ov-hero expose data-ov-hero-zone quelle que soit sa disposition ;
    // #ov-home-hero-zone reste pour l'ancienne section ov-home-hero.
    var heroZone = document.querySelector('#ov-home-hero-zone, [data-ov-hero-zone]');
    var buyZone = document.getElementById('ov-pdp-buying');
    if (!bar || !('IntersectionObserver' in window)) return;
    bar.removeAttribute('aria-hidden');
    // Le markup arrive visible : sans ca la barre s'affiche puis glisse hors
    // champ des que l'observer confirme que la hero est a l'ecran.
    if (heroZone) bar.setAttribute('data-visible', 'false');
    var heroVisible = false;
    var buyVisible = false;
    var footerVisible = false;
    function updateBar() {
      var hide = heroVisible || footerVisible || buyVisible;
      bar.setAttribute('data-visible', hide ? 'false' : 'true');
    }
    if (heroZone) {
      new IntersectionObserver(function(entries) {
        heroVisible = entries[entries.length - 1].isIntersecting;
        updateBar();
      }, { threshold: 0 }).observe(heroZone);
    }
    if (buyZone) {
      new IntersectionObserver(function(entries) {
        buyVisible = entries[entries.length - 1].isIntersecting;
        updateBar();
      }, { threshold: 0 }).observe(buyZone);
    }
    var footer = document.querySelector('#shopify-section-ov-footer');
    if (footer) {
      new IntersectionObserver(function(entries) {
        footerVisible = entries[entries.length - 1].isIntersecting;
        updateBar();
      }, { threshold: 0 }).observe(footer);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpStickyBar);
  } else {
    initPdpStickyBar();
  }

  // ── State ──────────────────────────────────────────────────────────────────
  var _pdpQty = 1;
  var _pdpMode = 'once'; // 'sub' | 'once'
  var _pdpPlanId = null;
  var _pdpPlanPct = 0;
  var _pdpAdding = false;
  var _packGroup = document.getElementById('ov-pdp-pack-group');
  var _cupsPerPot = _packGroup ? parseInt(_packGroup.getAttribute('data-cups-per-pot') || '0', 10) : 0;
  var _pricePerPot = _packGroup ? parseInt(_packGroup.getAttribute('data-price-per-pot') || '0', 10) : 0;
  var _compareAtPerPot = _packGroup ? parseInt(_packGroup.getAttribute('data-compare-at-per-pot') || '0', 10) : 0;

  // Init subscription mode
  var _firstFreqBtn = document.querySelector('[data-plan-id][data-active="true"]') || document.querySelector('[data-plan-id]');
  if (_firstFreqBtn) {
    _pdpMode = 'sub';
    _pdpPlanId = _firstFreqBtn.getAttribute('data-plan-id');
    _pdpPlanPct = parseInt(_firstFreqBtn.getAttribute('data-plan-pct') || '0', 10);
  }

  // ── Money formatter ────────────────────────────────────────────────────────
  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // ── Price update ───────────────────────────────────────────────────────────
  function updatePrices() {
    var rawTotal = _pricePerPot * _pdpQty;
    var displayTotal = rawTotal;
    var isSub = _pdpMode === 'sub' && _pdpPlanPct > 0;

    if (isSub) {
      displayTotal = Math.round(rawTotal * (100 - _pdpPlanPct) / 100);
    }

    var displayStr = fmt(displayTotal);
    var originalStr = fmt(rawTotal);

    // Compare-at (bundle sale) price — ATC button only
    var atcCompareEl = document.getElementById('ov-pdp-atc-compare-price');
    if (atcCompareEl) {
      var hasCompareAt = !isSub && _compareAtPerPot > _pricePerPot;
      atcCompareEl.textContent = fmt(_compareAtPerPot * _pdpQty);
      atcCompareEl.style.display = hasCompareAt ? '' : 'none';
    }

    // Main price display
    var dispEl = document.getElementById('ov-pdp-display-price');
    if (dispEl) dispEl.textContent = displayStr;

    var origEl = document.getElementById('ov-pdp-original-price');
    if (origEl) {
      origEl.textContent = originalStr;
      origEl.style.display = isSub ? '' : 'none';
    }

    // Pack summary label
    var sumEl = document.getElementById('ov-pdp-pack-summary');
    if (sumEl) sumEl.textContent = 'le pack ' + _pdpQty + (_pdpQty === 1 ? ' pot' : ' pots');

    // ATC buttons price spans
    document.querySelectorAll('[data-pdp-price]').forEach(function(el) {
      el.textContent = displayStr;
    });

    // Pack card prices
    document.querySelectorAll('[data-pack-raw-price]').forEach(function(card) {
      var raw = parseInt(card.getAttribute('data-pack-raw-price'), 10);
      var discounted = isSub ? Math.round(raw * (100 - _pdpPlanPct) / 100) : raw;
      var priceEl = card.querySelector('[data-pack-price]');
      if (priceEl) priceEl.textContent = fmt(discounted);
      var cupPriceEl = card.querySelector('[data-pack-cup-price]');
      if (cupPriceEl && _cupsPerPot > 0) {
        var qty = parseInt(card.getAttribute('data-pack-qty'), 10);
        var cpCents = Math.round(discounted / (qty * _cupsPerPot));
        cupPriceEl.textContent = fmt(cpCents) + ' / tasse';
      }
    });

    // Selling plan input
    var spInput = document.getElementById('ov-pdp-selling-plan-input');
    if (spInput) spInput.value = (isSub && _pdpPlanId) ? _pdpPlanId : '';

    // Price per cup
    var cupEl = document.getElementById('ov-pdp-cup-price-line');
    if (cupEl && _cupsPerPot > 0) {
      var cpCents = Math.round(displayTotal / (_pdpQty * _cupsPerPot));
      cupEl.textContent = 'soit ' + fmt(cpCents) + ' la tasse';
    }

    // Sticky bar
    var stickyPrice = document.getElementById('ov-sticky-price');
    if (stickyPrice) stickyPrice.textContent = displayStr;

    var stickyOrig = document.getElementById('ov-sticky-original-price');
    if (stickyOrig) {
      stickyOrig.textContent = originalStr;
      stickyOrig.style.display = isSub ? '' : 'none';
    }
  }

  // ── Pack qty selector ──────────────────────────────────────────────────────
  function setQty(qty) {
    _pdpQty = qty;

    document.querySelectorAll('[data-pack-qty]').forEach(function(btn) {
      btn.setAttribute('data-pack-active', parseInt(btn.getAttribute('data-pack-qty'), 10) === qty ? 'true' : 'false');
    });

    var lbl = document.getElementById('ov-pdp-pack-label');
    if (lbl) lbl.textContent = qty + (qty === 1 ? ' pot' : ' pots');

    if (_cupsPerPot > 0) {
      var cupsEl = document.getElementById('ov-pdp-cups-total');
      if (cupsEl) {
        var total = _cupsPerPot * qty;
        cupsEl.textContent = total + ' tasse' + (total > 1 ? 's' : '') + ' au total';
      }
    }

    // Flavor pill hrefs: append ?pack=N
    document.querySelectorAll('[data-flavor-url]').forEach(function(a) {
      var base = a.getAttribute('data-flavor-url');
      a.href = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'pack=' + qty;
    });

    // Sticky qty
    var sqEl = document.getElementById('ov-sticky-qty');
    if (sqEl) sqEl.textContent = qty;
    var sqPlural = document.getElementById('ov-sticky-qty-plural');
    if (sqPlural) sqPlural.textContent = qty > 1 ? 's' : '';

    updatePrices();
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-pack-qty]');
    if (!btn) return;
    setQty(parseInt(btn.getAttribute('data-pack-qty'), 10));
  });

  // Read ?pack= from URL on load
  var urlPack = new URLSearchParams(window.location.search).get('pack');
  var initQty = urlPack ? Math.min(4, Math.max(1, parseInt(urlPack, 10))) : 1;
  if (initQty !== 1) setQty(initQty);

  // ── Subscription tabs ──────────────────────────────────────────────────────
  function setMode(mode) {
    _pdpMode = mode;

    document.querySelectorAll('[data-purchase-mode]').forEach(function(btn) {
      btn.setAttribute('data-active', btn.getAttribute('data-purchase-mode') === mode ? 'true' : 'false');
    });

    var subPanel = document.getElementById('ov-pdp-sub-panel');
    if (subPanel) subPanel.setAttribute('data-visible', mode === 'sub' ? 'true' : 'false');

    // Sticky sub label
    updateStickySubLabel();
    updatePrices();
  }

  document.addEventListener('click', function(e) {
    var tab = e.target.closest('[data-purchase-mode]');
    if (!tab) return;
    setMode(tab.getAttribute('data-purchase-mode'));
  });

  // ── Frequency pills ────────────────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-plan-id]');
    if (!btn) return;
    _pdpPlanId = btn.getAttribute('data-plan-id');
    _pdpPlanPct = parseInt(btn.getAttribute('data-plan-pct') || '0', 10);

    document.querySelectorAll('[data-plan-id]').forEach(function(b) {
      b.setAttribute('data-active', b === btn ? 'true' : 'false');
    });

    updateStickySubLabel();
    updatePrices();
  });

  // ── Sticky sub label ───────────────────────────────────────────────────────
  function updateStickySubLabel() {
    var el = document.getElementById('ov-sticky-sub-label');
    if (!el) return;
    if (_pdpMode === 'sub' && _pdpPlanId) {
      var activeBtn = document.querySelector('[data-plan-id="' + _pdpPlanId + '"]');
      var planName = activeBtn ? activeBtn.firstChild.textContent.trim() : '';
      var cups = _cupsPerPot * _pdpQty;
      el.textContent = planName + (cups > 0 ? ' · ' + cups + ' tasse' + (cups > 1 ? 's' : '') : '');
    } else {
      var cups2 = _cupsPerPot * _pdpQty;
      el.textContent = 'Achat unique' + (cups2 > 0 ? ' · ' + cups2 + ' tasse' + (cups2 > 1 ? 's' : '') : '');
    }
  }

  // ── ATC ───────────────────────────────────────────────────────────────────
  function setAtcLoading(on) {
    document.querySelectorAll('[data-pdp-atc]').forEach(function(btn) {
      if (on) {
        btn.disabled = true;
        btn._ovOrig = btn.innerHTML;
        btn.innerHTML = '&hellip;';
      } else {
        btn.disabled = false;
        if (btn._ovOrig) { btn.innerHTML = btn._ovOrig; btn._ovOrig = null; }
      }
    });
  }

  function addToCart() {
    if (!window.liquidAjaxCart || !window.liquidAjaxCart.add) return;
    var hi = document.getElementById('ov-pdp-variant-id');
    var vid = hi ? parseInt(hi.value, 10) : 0;
    if (!vid) return;
    var fd = new FormData();
    fd.append('id', vid);
    fd.append('quantity', _pdpQty);
    if (_pdpMode === 'sub' && _pdpPlanId) {
      fd.append('selling_plan', _pdpPlanId);
    }
    setAtcLoading(true);
    _pdpAdding = true;
    window.liquidAjaxCart.add(fd);
  }

  document.addEventListener('liquid-ajax-cart:queue-end', function() {
    setAtcLoading(false);
    if (_pdpAdding) {
      _pdpAdding = false;
      document.dispatchEvent(new CustomEvent('ov:cart:open'));
    }
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-pdp-atc]')) addToCart();
  });

  // ── Init ───────────────────────────────────────────────────────────────────
  updateStickySubLabel();
  updatePrices();
}
